// TIMELINE COMPONENT
Vue.component('v-timeline', {
	name: 'v-timeline',
	template: '<div class="time_line"><div class="active_line" :style="lineSize"></div><div class="points"><div @click="clickedPhase(point)" v-for="point in points" :class="[\'point\', ($index <= active_index) && \'active\']"><span>{{ point.name }}</span></div></div></div>',
	props: ['points', 'point', 'key_id'],
	data: function() {
		return {
			active_index: 0
		}
	},
	watch: {
		point: function() {
			for (var i = 0, i_ = this.points.length; i < i_; i ++) {
				if (this.points[i][this.key_id] == this.point[this.key_id]) {
					this.active_index = i;
				}
			}
		}
    },
    methods: {
        clickedPhase: function(point) {
            this.$emit('change', point);
        }
    },
	computed: {
		lineSize: function() {
			if (this.active_index == 0) {
				return '6px';
			}

			var type = (window.innerWidth < 1200) ? 'height' : 'width';
			
			var size = (this.points.length - 1) / (this.active_index),
                width = (100 / size) + '%';
			
			var ret = {};

			ret[type] = width;

			return ret;
		}
	}
});